import React from 'react';
import Icon from './Icon';

const Plus = ({ width = '12', height = ' 12', fill = 'currentColor' }) => {
  return (
    <Icon width={width} height={height} viewBox="0 0 12 12">
      <path
        d="M12 7.023V4.977a.641.641 0 0 0-.643-.643h-3.69V.643A.641.641 0 0 0 7.022 0H4.977a.641.641 0 0 0-.643.643v3.69H.643A.641.641 0 0 0 0 4.978v2.046c0 .356.287.643.643.643h3.69v3.691c0 .356.288.643.644.643h2.046a.641.641 0 0 0 .643-.643v-3.69h3.691A.641.641 0 0 0 12 7.022Z"
        fill={fill}
        fillRule="nonzero"
      />
    </Icon>
  );
};

export default Plus;
